<template>
    <div>
        <link rel="stylesheet" href="/css/front.css">
        <router-link class="brand" tag="a" to="/">ipcim.info</router-link>
        <transition name="menu-popover" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
    </div>
</template>
<script>
    import Index from './Components/Index.vue';
    import Page from './Components/Page.vue';

    export default {
        name: 'app',
        components: {
            vIndex: Index,
            vPage: Page
        }
    }
</script>
<style scoped>
    .menu-popover-enter,
    .menu-popover-leave-to {
        opacity: 0;
    }

    .menu-popover-enter-to,
    .menu-popover-leave {
        opacity: 1;
    }

    .menu-popover-enter-active,
    .menu-popover-leave-active {
        transition: opacity 175ms ease-out;
    }


</style>
